import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { TemplateService } from 'app/_services/template.service';
import { TokenStorageService } from '../../_services/token-storage.service';

@Component({
  selector: 'app-add-template',
  templateUrl: './add-template.component.html'
})
export class AddTemplateComponent implements OnInit {
  templatesTypes: any = [];
  templateInfo: any = {};

  addTemplateForm: FormGroup = new FormGroup({
    template_type: new FormControl(""),
    template_name: new FormControl(""),
    template_content: new FormControl("")
  })

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private template: TemplateService,
    private tokenStorage: TokenStorageService,
  ) { }

  ngOnInit(): void {
    const contactUUID = this.tokenStorage.getToken() || "";
    const templateid = this.activatedRoute.snapshot.params['templateid'];
   
    this.template.getTemplatesTypes$(contactUUID).subscribe((types: {}) => {
      this.templatesTypes = types;
      console.log("Types ", this.templatesTypes)
    })
  }

  onSubmit(values: any): void {
    const contactUUID = this.tokenStorage.getToken() || "";

    let templateInfo: any = {
      template_type_id: values.template_type,
      template_name: values.template_name,
      template: values.template_content
    };

    console.log("templateInfo ", templateInfo)

    this.template.addTemplate$(contactUUID, templateInfo).subscribe({
      next: (data: any) => {
        console.log("Data --> ", data);
        this.router.navigate(['maquettes']);
      },
      error: (err: any) => {
        console.log("Something went wrong: ", err.statusText)
      }
    });
  }
}